import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Formik} from 'formik'
import {Form} from 'react-bootstrap'
import {InputWithPhone} from '../../widgets/components/Input/InputPhone'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import {useThemeMode} from '../../../../_metronic/partials'
import * as Yup from 'yup'
import parsePhoneNumberFromString, {isValidPhoneNumber} from 'libphonenumber-js'
import {createOtp} from '../core/_requests'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import TagManager from 'react-gtm-module'
import {removeNullFields} from '../../../core/_util'
import {phoneCodes} from '../../profile/core/_constants'

const PhoneVerification = () => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  // const {phoneCodesOptions} = useGetAllDropdownData(ShareholdersTypes.INDIVIDUAL)
  const navigate = useNavigate()
  const {currentUser, companyId} = useAuth()
  const [loading, setLoading] = useState(false)
  const userId = localStorage.getItem('userId')
  const initialValues = {
    countryDialingCode: currentUser?.countryDialingCode,
    phoneNumber: '',
  }

  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .nullable()
      .test('phone-number-valid', 'Invalid phone number', function (value, ctx: any) {
        if (!value || value === '') return true

        const selectedPhoneCode = ctx.parent.countryDialingCode
        const selectedCountryCode = phoneCodes.find(
          (option: any) => option.dial_code === selectedPhoneCode
        )?.code

        if (phoneCodes.length === 0 && ctx.originalValue) {
          return true // Invalid phone code
        }

        try {
          const phoneNumber = String(ctx.originalValue)
          const parsedNumber = parsePhoneNumberFromString(phoneNumber, selectedCountryCode)

          return isValidPhoneNumber(parsedNumber?.number as string)
        } catch (error) {
          return false
        }
      }),
  })

  const handleSubmit = async (values: any) => {
    console.log(values, ' formik')
    setLoading(true)
    try {
      const payload: any = {
        countryDialingCode: values?.countryDialingCode,
        phoneNumber: values?.phoneNumber,
      }
      const {
        data: {data, success, errors},
      } = await createOtp(+companyId!, payload)
      if (success) {
        localStorage.setItem('countryDialingCode', values?.countryDialingCode)
        localStorage.setItem('phoneNumber', values?.phoneNumber)
        // navigate(`/auth/verify-phone/otp/${currentUser?.userId}`) // Pass data via state
        navigate(`/auth/verify-phone/otp/${userId || currentUser?.userId}`) // Pass data via state
        toast.success(formatMessage({id: data}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.PhoneVerificationStartSuccessful,
            metadata: removeNullFields({
              user_id: currentUser?.userId,
              user_hash: currentUser?.user_hash,
              email: currentUser?.email,
              phone: `${values?.countryDialingCode}${values?.phoneNumber}`,
              company: {
                company_id: companyId,
              },
            }),
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.PhoneVerificationStartFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              user_hash: currentUser?.user_hash,
              email: currentUser?.email,
              phone: `${values?.countryDialingCode}${values?.phoneNumber}`,
              company: {
                company_id: companyId,
              },
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.PhoneVerificationStartFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            user_hash: currentUser?.user_hash,
            email: currentUser?.email,
            phone: `${values?.countryDialingCode}${values?.phoneNumber}`,
            company: {
              company_id: companyId,
            },
            error: err,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden' // Disable scrolling
    return () => {
      document.body.style.overflow = 'auto' // Restore scrolling when component unmounts
    }
  }, [])

  return (
    <div>
      <div className=''>
        <div className='d-flex align-items-center justify-content-center h-100'>
          <div className='d-flex flex-column justify-content-center align-items-center otp-screen py-6 px-md-0 px-2 gap-6 w-100'>
            <img
              src={toAbsoluteUrl(`/media/auth/oneMoreStep${mode === 'dark' ? `-dark` : ``}.svg`)}
              width='168'
              height='126'
              alt='one-more-step'
              className='mt-6'
            />
            <div className='d-flex flex-column align-items-center justify-content-center gap-6 col-md-9 col-11'>
              <div>
                <h1 className='mb-0 text-center font-size-20'>
                  {formatMessage({
                    id: `Almost There!`,
                  })}
                </h1>
                <h1 className='mb-0 text-center font-size-20'>
                  {formatMessage({
                    id: `Just One More Step!`,
                  })}
                </h1>
              </div>
              <div>
                {/* <p className='mb-0 text-center'>
                {formatMessage({
                  id: `Let’s quickly verify your contact number so you`,
                })}
              </p>
              <p className='mb-0 text-center'>
                {formatMessage({
                  id: `can start managing your records with ease.`,
                })}
              </p>
              <p className='mb-0 text-center'>
                {formatMessage({
                  id: `Ready to go? Let's do this!`,
                })}
              </p> */}
                <p className='mb-0 text-center'>
                  {formatMessage({
                    id: `Let’s quickly verify your contact number so you can start managing your records with ease.`,
                  })}
                </p>
                <p className='mb-0 text-center'>
                  {formatMessage({
                    id: `Ready to go? Let's do this!`,
                  })}
                </p>
              </div>
            </div>
            <Formik
              validationSchema={validationSchema}
              initialValues={initialValues}
              enableReinitialize={true}
              onSubmit={handleSubmit}
              validateOnMount
            >
              {(formik) => (
                <Form className='d-flex flex-column align-items-center gap-4 w-100 mb-6'>
                  <div className='col-lg-12 col-11'>
                    <InputWithPhone
                      label={formatMessage({id: 'Phone'})}
                      toolTipText={formatMessage({
                        id: 'Enter your phone number for secure verification and access to your RecordsKeeper.AI account.',
                      })}
                      fieldName='phoneNumber'
                      placeholder={formatMessage({id: 'Enter Phone Number'})}
                      placeholderSelect={formatMessage({id: 'Select'})}
                      formik={formik}
                      options={phoneCodes}
                      selectOptionFieldName='countryDialingCode'
                      isStarRequired
                      isTooltipForModal
                    />
                  </div>
                  <BasicButton
                    buttonText={formatMessage({id: 'Send OTP'})}
                    height='44px'
                    customClass='bg-primary text-white'
                    padding='12px 24px'
                    loading={loading}
                    onClick={() => handleSubmit(formik.values)}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PhoneVerification
